import React from 'react'
import { FileTextOutlined, PlayCircleOutlined, GiftOutlined } from '@ant-design/icons'
import { message } from 'antd'
import type { SkillKey, HistoryItem } from '../types'

interface RightPanelProps {
  activeSkill: SkillKey
  activeHistory: string | null
  historyList: HistoryItem[]
}

export const RightPanel: React.FC<RightPanelProps> = ({
  activeSkill,
  activeHistory,
  historyList
}) => {
  // 判断当前是否显示活动安排内容
  const isActivityActive = activeSkill === 'activity' || 
    (activeHistory && historyList.find(h => h.id === activeHistory)?.skill === 'activity')

  // 判断当前是否显示系统操作内容
  const isSystemActive = activeSkill === 'system' || 
    (activeHistory && historyList.find(h => h.id === activeHistory)?.skill === 'system')

  // 判断当前是否显示课例学习内容
  const isLearningActive = activeSkill === 'learning' || 
    (activeHistory && historyList.find(h => h.id === activeHistory)?.skill === 'learning')

  // 判断当前是否显示成长锦囊内容
  const isGrowthActive = activeSkill === 'growth' ||
    (activeHistory && historyList.find(h => h.id === activeHistory)?.skill === 'growth')

  // const handleToolClick = (_toolName: string) => {
  //   message.info('待发布')
  // }

  return (
    <aside className="right-sidebar">
      {isActivityActive && (
        <div className="panel-section">
          <div className="tool-list">
            <div
              className="tool-item"
              onClick={() => window.open('https://apaas.grtcloud.net/preview/onlinePreview?url=aHR0cHM6Ly90dGNkdzYtcHVibGljLm9zcy1jbi1iZWlqaW5nLmFsaXl1bmNzLmNvbS8xNzcwNzY4NTk2NDk0MDEyNDE3LzNlYjBlNWE0NzA1ZTBkNmM0ODY0N2Y1YmMwN2ExZjY3LnBkZg%3D%3D', '_blank')}
            >
              <span className="tool-icon"><FileTextOutlined /></span>
              <span className="tool-name">第十届启航杯实施细则</span>
            </div>
          </div>
        </div>
      )}

      {isSystemActive && (
        <div className="panel-section">
          <div className="tool-list">
            <div
              className="tool-item"
              onClick={() => window.open('https://apaas.grtcloud.net/preview/onlinePreview?url=aHR0cHM6Ly90dGNkdzYtcHVibGljLm9zcy1jbi1iZWlqaW5nLmFsaXl1bmNzLmNvbS8xNzcwNzY4NTk2NDk0MDEyNDE3L2JlNDBkYjMxNWVlNjI1YWI2NWYxZjA5YjFlM2Q3NDJmLmRvY3g%3D', '_blank')}
            >
              <span className="tool-icon"><FileTextOutlined /></span>
              <span className="tool-name">第十届启航杯新教师操作指南</span>
            </div>
            <div
              className="tool-item"
              title="暂未公布"
              onClick={() => message.info('暂未公布')}
            >
              <span className="tool-icon"><FileTextOutlined /></span>
              <span className="tool-name">学习公社 AI 课堂教学行为分析操作指南</span>
            </div>
          </div>
        </div>
      )}

      {isLearningActive && (
        <div className="panel-section">
          <div className="tool-list">
            <div className="tool-item" onClick={() => window.open('https://www.bjteachers.cn/h/home/sxkcgb/', '_blank')}>
              <span className="tool-icon"><PlayCircleOutlined /></span>
              <span className="tool-name">历届作品全集</span>
            </div>
          </div>
        </div>
      )}

      {isGrowthActive && (
        <div className="panel-section">
          <div className="tool-list">
            <div
              className="tool-item"
              onClick={() => window.open('https://ttcdw.guorent.com/%E5%8C%97%E4%BA%AC%E6%95%99%E5%B8%88%E5%AD%A6%E4%B9%A0%E7%BD%91/%E6%96%B0%E5%B0%8F%E5%B8%88/teaching-question-match.html', '_blank')}
            >
              <span className="tool-icon"><GiftOutlined /></span>
              <span className="tool-name">随机抽取成长锦囊</span>
            </div>
          </div>
        </div>
      )}
    </aside>
  )
}
